import React from "react";

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
          <div className="w-24 h-24 rounded-full animate-spin
                    border-x-4 border-dashed border-black border-t-transparent"></div>
                    </div>
               
 
  );
};

export default Loader;
